import marcarPaso from './marcarPaso';
import siguientePaso from './siguientePaso';
import validarNombre from './validaciones/validarNombre';
import validarCorreo from './validaciones/validarCorreo';
import validarTelefono from './validaciones/validarTelefono';
import recogeDatos from './recogeDatos';

const formulario = document.getElementById('formulario');


// Reiniciando scroll al cargar el formulario.
formulario.querySelector('.formulario__body').scrollLeft = 0;

// Eventlistener para comprobar los campos de formulario cuando el usuario corrige.
formulario.addEventListener('keyup', (e) => {
	if (e.target.tagName === 'INPUT') {
		if (e.target.id === 'nombre-receptor') {
			validarNombre();
		} else if (e.target.id === 'cantidad') {
			validarTelefono();
		} else if (e.target.id === 'correo-receptor') {
			validarCorreo();
		}
	}
});

const btnBuscar = document.getElementById('buscar');
btnBuscar.addEventListener('click', (e) => {
	e.preventDefault();

	btnBuscar.addEventListener('click', () => {
		recogeDatos();
	});
});

const btnFormulario = document.getElementById('formulario__btn');
btnFormulario.addEventListener('click', (e) => {
	e.preventDefault();

	// Validamos el paso actual.
	const pasoActual = document.querySelector('.linea-pasos__paso-check--active').closest('.linea-pasos__paso')
		.dataset.paso;

	if (pasoActual === 'nombre-receptor') {
		if (validarNombre()) {
			recogeDatos();
			marcarPaso('nombre-receptor');
			siguientePaso();
		}
	} else if (pasoActual === 'datos') {
		if (validarTelefono() && validarCorreo()) {
			marcarPaso('datos');
			siguientePaso();
		}
	} else if (pasoActual === 'metodo') {
		marcarPaso('metodo');

		const pase = document.getElementById('resultadoPases').innerText;
		console.log(pase);
		
		
		// Obtenemos los valores del formulario y los pasamos a la seccion de confirmar.
		
		
		
		
		document.querySelector('[data-valor="pases"] span').innerText = pase;
		document.querySelector('[data-valor="cantidad"] span').innerText = formulario['cantidad'].value;
		document.querySelector('[data-valor="correo-receptor"] span').innerText = formulario['correo-receptor'].value;
		document.querySelector('[data-valor="metodo"] span').innerText = formulario.metodo.value;
		

		// Cambiamos el texto del btn a 'Transferir'
		btnFormulario.querySelector('span').innerText = 'Enviar';

		// Agregamos la clase que deshabilita el boton.
		btnFormulario.classList.add('formulario__btn--disabled');

		// Ocultamos el icono de siguiente.
		btnFormulario
			.querySelector('[data-icono="siguiente"]')
			.classList.remove('formulario__btn-contenedor-icono--active');

		// Mostramos el icono del banco.
		btnFormulario.querySelector('[data-icono="banco"]').classList.add('formulario__btn-contenedor-icono--active');

		siguientePaso();

		// Eliminamos la clase de disabled despues de 4 segundos.
		setTimeout(() => {
			btnFormulario.classList.remove('formulario__btn--disabled');
		}, 4000);

		// Comprobamos si estamos en el paso actual y el boton no tiene la clase de disabled
	} else if (pasoActual === 'confirmacion' && !btnFormulario.matches('.formulario__btn--disabled')) {
		// Aqui se haria una peticion al servidor, una redireccion, etc.

		// Cambiamos el texto del btn a 'Transferir'
		btnFormulario.querySelector('span').innerText = 'Enviando...';
		// Agregamos la clase que deshabilita el boton.
		btnFormulario.classList.add('formulario__btn--disabled');

		setTimeout(() => {
			formulario.classList.add('formulario--hidden');
			document.getElementById('alerta').classList.add('alerta--active');
		}, 4000);
	} else {
		siguientePaso();
	}

	if (document.querySelector("#tarjeta").checked) {
        document.querySelector("#iraono").innerHTML = " Gracias por confirmar nos encantará verle.";
    }
    else if (document.querySelector("#cheques").checked) {
        document.querySelector("#iraono").innerHTML = " Gracias por avisar sentimos que no pueda acompañarnos.";

    }
});
